import { DashboardItem } from '@features/base/private/appbar/DashboardItem';

export const NewsDashboardItem = () => {
  return (
    <DashboardItem
      dashboard={{
        id: -1,
        name: 'Freemium News',
        json: {
          layouts: {},
          widgets: [],
          zIndices: {},
        },
        websocket_uid: '123',
        last_modified: new Date().toISOString(),
        user_id: '123',
      }}
      hideIcons={true}
      dashboardToDelete={null}
      setAnchorEl={() => {}}
      setDashboardToShare={() => {}}
      setDashboardToDelete={() => {}}
      freemiumPath="/freemium/news"
    />
  );
};

export const MarketsDashboardItem = () => {
  return (
    <DashboardItem
      dashboard={{
        id: -2,
        name: 'Freemium Markets',
        json: {
          layouts: {},
          widgets: [],
          zIndices: {},
        },
        websocket_uid: '123',
        last_modified: new Date().toISOString(),
        user_id: '123',
      }}
      hideIcons={true}
      dashboardToDelete={null}
      setAnchorEl={() => {}}
      setDashboardToShare={() => {}}
      setDashboardToDelete={() => {}}
      freemiumPath="/freemium/markets"
    />
  );
};
